import Vue from "vue";

const END_POINT = "/misc";

const getConstants = payload =>
  Vue.axios.get(`${END_POINT}/constants/${payload}`);

const getCountries = () => Vue.axios.get(`${END_POINT}/countries`);

const getSurveyFlows = () => Vue.axios.get(`${END_POINT}/surveyflows`);

const getRegions = () => Vue.axios.get(`${END_POINT}/regions`);

const getRegionsByCountry = countryId =>
  Vue.axios.get(`${END_POINT}/regions/${countryId}`);

export {
  getConstants,
  getCountries,
  getRegions,
  getRegionsByCountry,
  getSurveyFlows
};
